
import { ADD_CONNECTION_ITEM, CONNECTION_CATEGORY_ADD_ITEM, CONNECTION_CATEGORY_DELETE, CONNECTION_CATEGORY_UPDATE, DELETE_CONNECTION_ITEM, GET_ALL_CONNECTION, GET_ALL_CONNECTION_CATEGORY, GET_ALL_CONNECTION_FAILED, GET_ALL_CONNECTION_SUCCESS } from '../../constants/connectionConstants';

const initialState = {
    connectionData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    category: {
        data: [],
        pagination: {}
    },
    isLoading: false,
    error: null
};

export default function connectionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_CONNECTION:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case GET_ALL_CONNECTION_SUCCESS:
            const isFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                connectionData: {
                    data: isFirstPage
                        ? action.payload.data
                        : [...state.connectionData.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };
        case DELETE_CONNECTION_ITEM:
            const itemId = action.payload.id
            return {
                ...state,
                isLoading: false,
                connectionData: {
                    ...state.connectionData,
                    data: state.connectionData.data.filter(item => item.connectID !== itemId)
                }
            };
        case ADD_CONNECTION_ITEM:
            return {
                ...state,
                isLoading: false,

                connectionData: {
                    ...state.connectionData,
                    data:  [...state.connectionData.data, action.payload.data.data]
                }
            };
        case GET_ALL_CONNECTION_CATEGORY:
            const isCatFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                category: {
                    data: isCatFirstPage
                        ? action.payload.data
                        : [...state.category.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };
        case CONNECTION_CATEGORY_ADD_ITEM: {
            const categoryId = action.payload.catId;
            const categoryItem = action.payload.item;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.map(item =>
                        item.id === categoryId
                            ? {
                                ...item,
                                items: item.items ?
                                    item.items.some(existingItem => existingItem.id === categoryItem.id)
                                        ? item.items
                                        : [...item.items, categoryItem]
                                    : [categoryItem],
                                itemCount: (item.items && item.items.some(existingItem => existingItem.id === categoryItem.id))
                                    ? item.itemCount
                                    : (item.itemCount || 0) + 1
                            }
                            : item
                    )
                },
                isLoading: false
            };
        }
        case CONNECTION_CATEGORY_DELETE: {
            const categoryId = action.payload.catId;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.filter(item => item.id !== categoryId)
                },
                isLoading: false
            };
        }
        case CONNECTION_CATEGORY_UPDATE: {
            const categoryId = action.payload.catId;
            const updatedTitle = action.payload.title;
            const updatedData = [action.payload.data];
            // console.log(updatedData)

            return {
                ...state,
                category: {
                    ...state.category,
                    data: (!Array.isArray(state.category.data) || state.category.data.length === 0)
                        ? updatedData
                        : state.category.data.map(item =>
                            item.id === categoryId ? { ...item, title: updatedTitle } : item
                        )
                },
                isLoading: false
            };
        }
        case GET_ALL_CONNECTION_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
}